<template>
  <v-dialog :model-value="uploadAssignmentDialog" max-width="600">
    <v-card>
      <v-card-title>
        <v-row no-gutters align="center">
          <span>{{
            selectedTugas.extendedProps.name ||
            selectedTugas.extendedProps.title
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            size="small"
            variant="text"
            @click="$emit('closeUploadAssignmentDialog')"
          ></v-btn>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <template v-if="useBelajarWajibTerjadwalStore().loading">
        <v-col cols="12">
          <v-skeleton-loader type="article" />
        </v-col>
      </template>
      <template v-else-if="isGroupless">
        <v-alert
          color="red"
          icon="mdi-information-outline"
          variant="tonal"
          class="ma-4"
          text="Anda belum memiliki kelompok, coba hubungi penyelenggara pelatihan."
        ></v-alert>
      </template>
      <template v-else>
        <v-form fast-fail ref="form" @submit.prevent="checkFormValidity">
          <v-card-text>
            <p class="mb-3">
              {{ selectedTugas.extendedProps.description }}
            </p>
            <template
              v-if="selectedTugas.extendedProps.aktivityType === 'VISITASI'"
            >
              <v-alert
                v-if="isGroupVisitationSubmitted"
                color="info"
                icon="mdi-information-outline"
                variant="tonal"
                class="mb-3"
                text="Kelompok Anda sudah mengumpulkan laporan sebelumnya"
              ></v-alert>
              <v-alert
                v-if="isIndividualVisitationSubmitted"
                color="info"
                icon="mdi-information-outline"
                variant="tonal"
                class="mb-3"
                text="Anda sudah mengumpulkan laporan individu"
              ></v-alert>
              <v-text-field
                v-model="tugasPayload.visitationAssignmentForGroup"
                :rules="rulesTugasLink"
                label="Link Laporan Kelompok"
                hint="Harap Link yang dibagikan bisa diakses oleh Tenaga Pelatihan"
                class="mt-5"
              >
                <template
                  v-if="isValidLink(tugasPayload.visitationAssignmentForGroup)"
                  v-slot:append
                >
                  <v-btn
                    :href="tugasPayload.visitationAssignmentForGroup"
                    variant="flat"
                    color="info"
                    density="comfortable"
                    target="_blank"
                    rel="noopener noreferrer"
                    icon
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Cek Laporan
                    </v-tooltip>
                  </v-btn>
                </template>
              </v-text-field>
              <v-text-field
                v-model="tugasPayload.visitationAssignmentForIndividual"
                :rules="rulesTugasLink"
                label="Link Laporan Individu"
                hint="Harap Link yang dibagikan bisa diakses oleh Tenaga Pelatihan"
                class="mt-3"
              >
                <template
                  v-if="
                    isValidLink(tugasPayload.visitationAssignmentForIndividual)
                  "
                  v-slot:append
                >
                  <v-btn
                    :href="tugasPayload.visitationAssignmentForIndividual"
                    variant="flat"
                    color="info"
                    density="comfortable"
                    target="_blank"
                    rel="noopener noreferrer"
                    icon
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Cek Laporan
                    </v-tooltip>
                  </v-btn>
                </template>
              </v-text-field>
            </template>
            <template
              v-else-if="
                selectedTugas.extendedProps.aktivityType === 'POLICY_BRIEF'
              "
            >
              <v-alert
                v-if="isPolicyBriefSubmitted"
                color="info"
                icon="mdi-information-outline"
                variant="tonal"
                class="mb-3"
                text="Kelompok Anda sudah mengumpulkan policy brief sebelumnya"
              ></v-alert>
              <v-text-field
                v-model="tugasPayload.policyBrief"
                :rules="rulesTugasLink"
                label="Link Policy Brief"
                hint="Harap Link yang dibagikan bisa diakses oleh Tenaga Pelatihan"
                class="mt-5"
              >
                <template
                  v-if="isValidLink(tugasPayload.policyBrief)"
                  v-slot:append
                >
                  <v-btn
                    :href="tugasPayload.policyBrief"
                    variant="flat"
                    color="info"
                    density="comfortable"
                    target="_blank"
                    rel="noopener noreferrer"
                    icon
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Cek Policy Brief
                    </v-tooltip>
                  </v-btn>
                </template>
              </v-text-field>
            </template>
            <template v-else>
              <v-alert
                v-if="isSubmitted"
                color="info"
                icon="mdi-information-outline"
                variant="tonal"
                class="mb-3"
                :text="`
                  ${
                    selectedTugas.extendedProps.haveWorkingGroup
                      ? 'Kelompok'
                      : ''
                  }
                  Anda sudah upload tugas sebelumnya
                `"
              ></v-alert>
              <template v-if="selectedTugas.extendedProps.haveWorkingGroup">
                <v-card
                  v-if="tugasPayload.tugasLink && !isEditMode"
                  class="mt-5 mb-3"
                  variant="tonal"
                  color="blue-grey-lighten-5"
                >
                  <v-card-text>
                    <v-row align="center" no-gutters>
                      <v-icon color="red" size="40" class="mr-3">
                        mdi-file-pdf-box
                      </v-icon>
                      <v-col>
                        <div class="text-subtitle-2 font-weight-bold">
                          File Tugas Kelompok Sudah Diupload
                        </div>
                        <div class="text-caption text-grey-darken-1">
                          Tugas Kelompok
                        </div>
                      </v-col>
                      <v-btn
                        @click="openPdfPreviewKelompok"
                        variant="flat"
                        :color="isKelompokLinkExternal ? 'info' : 'primary'"
                        size="small"
                        icon
                        class="mr-2"
                      >
                        <v-icon>{{
                          isKelompokLinkExternal ? "mdi-open-in-new" : "mdi-eye"
                        }}</v-icon>
                        <v-tooltip activator="parent" location="top">
                          {{
                            isKelompokLinkExternal
                              ? "Buka Tugas"
                              : "Preview PDF"
                          }}
                        </v-tooltip>
                      </v-btn>
                      <v-btn
                        @click="isEditMode = true"
                        variant="flat"
                        color="orange"
                        size="small"
                        icon
                      >
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Edit Tugas
                        </v-tooltip>
                      </v-btn>
                    </v-row>
                  </v-card-text>
                </v-card>
                <template v-else>
                  <v-file-input
                    v-model="tugasPayload.file"
                    :rules="rulesFile"
                    label="Upload File Tugas Kelompok*"
                    accept=".pdf,application/pdf"
                    prepend-icon="mdi-file-pdf-box"
                    hint="Hanya file PDF dengan ukuran maksimal 5 MB"
                    persistent-hint
                    show-size
                    class="mt-5"
                  ></v-file-input>
                  <v-btn
                    v-if="isEditMode"
                    @click="cancelEdit"
                    text="Batal Edit"
                    variant="text"
                    color="grey"
                    size="small"
                    class="mt-2"
                  ></v-btn>
                </template>
              </template>
              <template v-else>
                <v-card
                  v-if="
                    (tugasPayload.tugasLink || tugasPayload.guid) && !isEditMode
                  "
                  class="mt-5 mb-3"
                  variant="tonal"
                  color="blue-grey-lighten-5"
                >
                  <v-card-text>
                    <v-row align="center" no-gutters>
                      <v-icon color="red" size="40" class="mr-3">
                        mdi-file-pdf-box
                      </v-icon>
                      <v-col>
                        <div class="text-subtitle-2 font-weight-bold">
                          File Tugas Sudah Diupload
                        </div>
                        <div class="text-caption text-grey-darken-1">
                          {{
                            tugasPayload.description || "Tidak ada deskripsi"
                          }}
                        </div>
                      </v-col>
                      <v-btn
                        @click="openPdfPreview"
                        variant="flat"
                        color="primary"
                        size="small"
                        icon
                        class="mr-2"
                      >
                        <v-icon>mdi-eye</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Preview PDF
                        </v-tooltip>
                      </v-btn>
                      <v-btn
                        @click="isEditMode = true"
                        variant="flat"
                        color="orange"
                        size="small"
                        icon
                      >
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Edit Tugas
                        </v-tooltip>
                      </v-btn>
                    </v-row>
                  </v-card-text>
                </v-card>
                <template v-else>
                  <v-file-input
                    v-model="tugasPayload.file"
                    :rules="rulesFile"
                    label="Upload File Tugas*"
                    accept=".pdf,application/pdf"
                    prepend-icon="mdi-file-pdf-box"
                    hint="Hanya file PDF dengan ukuran maksimal 5 MB"
                    persistent-hint
                    show-size
                    class="mt-5"
                  ></v-file-input>
                  <v-textarea
                    v-model="tugasPayload.description"
                    label="Deskripsi"
                    rows="3"
                    class="mt-3"
                    hint="Masukkan deskripsi tugas (opsional)"
                  ></v-textarea>
                  <v-btn
                    v-if="isEditMode"
                    @click="cancelEdit"
                    text="Batal Edit"
                    variant="text"
                    color="grey"
                    size="small"
                    class="mt-2"
                  ></v-btn>
                </template>
              </template>
              <v-chip size="small" color="red">
                Batas akhir: {{ getEnd }}
              </v-chip>
            </template>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <template
              v-if="
                ((selectedTugas.extendedProps.haveWorkingGroup &&
                  tugasPayload.tugasLink) ||
                  (!selectedTugas.extendedProps.haveWorkingGroup &&
                    (tugasPayload.tugasLink || tugasPayload.guid))) &&
                !isEditMode
              "
            >
              <v-btn
                text="Tutup"
                class="text-none border"
                variant="flat"
                @click="$emit('closeUploadAssignmentDialog')"
              />
            </template>
            <template v-else>
              <v-btn
                text="Batal"
                class="text-none border"
                variant="flat"
                @click="$emit('closeUploadAssignmentDialog')"
              />
              <v-btn
                :loading="loading"
                text="Simpan"
                class="text-none ml-2"
                variant="flat"
                type="submit"
                color="blue-accent-4"
              />
            </template>
          </v-card-actions>
        </v-form>
      </template>
    </v-card>
  </v-dialog>

  <!-- PDF Preview Dialog - Tugas Individu -->
  <PembelajaranWajibDialogPreviewPdf
    :dialogPreviewPdf="previewPdfDialog"
    :guid="tugasPayload.guid"
    :source="'tugas'"
    title="Preview Tugas PDF"
    @closeDialogPreviewPdf="previewPdfDialog = false"
  />

  <!-- PDF Preview Dialog - Tugas Kelompok -->
  <PembelajaranWajibDialogPreviewPdf
    :dialogPreviewPdf="kelompokPreviewPdfDialog"
    :guid="tugasPayload.guid"
    :source="'kelompok-tugas'"
    title="Preview Tugas Kelompok PDF"
    @closeDialogPreviewPdf="kelompokPreviewPdfDialog = false"
  />
</template>
<script>
import moment from "moment";
import "moment/dist/locale/id";
import {
  isExternalLink,
  openLinkOrPreview,
} from "~/composables/useExternalLink";

export default {
  props: {
    selectedTugas: { type: Object, required: true },
    uploadAssignmentDialog: { type: Boolean, required: true },
    isFromNoftification: { type: Boolean, default: false },
    getEnd: { type: Object, required: true },
  },
  data() {
    return {
      tugasPayload: {},
      rulesTugasLink: [
        (value) => !!value || "Link Tugas wajib diisi.",
        (value) => {
          if (!value) return true;
          if (!value.match(/^https?:\/\//))
            return "Link harus dimulai dengan http:// atau https://";
          if (
            !value.match(
              /^https?:\/\/([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/.*)?$/,
            )
          )
            return "Link harus menyertakan domain yang valid";
          return true;
        },
      ],
      rulesFile: [
        (value) => {
          if (!value || value.length === 0) return "File tugas wajib diupload.";
          return true;
        },
        (value) => {
          if (!value || value.length === 0) return true;
          const file = value[0];
          if (!file) return true;
          if (file.type !== "application/pdf")
            return "File harus berformat PDF.";
          return true;
        },
        (value) => {
          if (!value || value.length === 0) return true;
          const file = value[0];
          if (!file) return true;
          const maxSize = 5 * 1024 * 1024; // 5 MB
          if (file.size > maxSize) return "Ukuran file maksimal 5 MB.";
          return true;
        },
      ],
      loading: false,
      isSubmitted: false,
      isIndividualVisitationSubmitted: false,
      isGroupVisitationSubmitted: false,
      isPolicyBriefSubmitted: false,
      previewPdfDialog: false,
      kelompokPreviewPdfDialog: false,
      isEditMode: false,
    };
  },
  computed: {
    profile() {
      return useBelajarWajibStore().profile || {};
    },
    aktifitasGuid() {
      return this.selectedTugas.extendedProps.guid;
    },
    batchId() {
      return useRoute().query.batchId;
    },
    isGroupless() {
      if (this.selectedTugas.extendedProps.haveWorkingGroup) {
        if (!this.tugasPayload.guid) {
          return true;
        }
      } else if (this.selectedTugas.extendedProps.aktivityType === "VISITASI") {
        return true;
      } else if (
        this.selectedTugas.extendedProps.aktivityType === "POLICY_BRIEF"
      ) {
        return true;
      }
      return false;
    },
    isKelompokLinkExternal() {
      return isExternalLink(this.tugasPayload?.tugasLink);
    },
  },
  watch: {
    async uploadAssignmentDialog(isOpen) {
      if (isOpen) {
        this.tugasPayload = {};
        this.isSubmitted = false;
        this.isIndividualVisitationSubmitted = false;
        this.isGroupVisitationSubmitted = false;
        this.isPolicyBriefSubmitted = false;
        this.previewPdfDialog = false;
        this.kelompokPreviewPdfDialog = false;
        this.isEditMode = false;
        // if (!this.isFromNoftification) {
        if (this.selectedTugas.extendedProps.aktivityType === "VISITASI") {
          this.getVisitationAssignment();
        } else if (
          this.selectedTugas.extendedProps.aktivityType === "POLICY_BRIEF"
        ) {
          this.getPolicyBriefAssignment();
        } else if (this.selectedTugas.extendedProps.haveWorkingGroup) {
          this.getGroup();
        } else {
          this.getTugasSubmittedIndividu();
        }
        // }
      }
    },
  },
  methods: {
    getEndTime(date) {
      return moment(date).format("dddd, DD MMMM YYYY, HH:mm");
    },
    checkFormValidity() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          if (this.selectedTugas.extendedProps.aktivityType === "VISITASI") {
            this.submitVisitationAssignment();
          } else if (
            this.selectedTugas.extendedProps.aktivityType === "POLICY_BRIEF"
          ) {
            this.submitPolicyBriefAssignment();
          } else {
            this.submitAssignment();
          }
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack: "Harap lengkapi kembali data Anda.",
          });
        }
      });
    },
    async submitPolicyBriefAssignment() {
      this.loading = true;
      const event = useRequestEvent();
      try {
        await fetchBelajarWajib(
          event,
          `/master-schedule/policy-brief`,
          "POST",
          {
            batchGuid: this.batchId,
            groupGuid: this.tugasPayload.kelompokKerja.guid,
            link: this.tugasPayload.policyBrief,
          },
        );
        await useBelajarWajibTerjadwalStore().getCourseDetail(this.batchId);
        useUserStore().$patch({
          snackStatus: "green",
          snackbar: true,
          messageSnack: "Policy brief sudah tersimpan.",
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
        }
      } finally {
        this.loading = false;
        this.$emit("closeUploadAssignmentDialog");
      }
    },
    async submitVisitationAssignment() {
      this.loading = true;
      const event = useRequestEvent();
      try {
        await Promise.all([
          fetchBelajarWajib(event, `/master-schedule/visitasi`, "POST", {
            activityGuid: this.aktifitasGuid,
            groupGuid: this.tugasPayload.kelompokKerja.guid,
            link: this.tugasPayload.visitationAssignmentForGroup,
          }),
          fetchBelajarWajib(
            event,
            `/master-schedule/visitasi/personal`,
            "POST",
            {
              activityGuid: this.aktifitasGuid,
              workingGroupGuid: this.tugasPayload.kelompokKerja.guid,
              link: this.tugasPayload.visitationAssignmentForIndividual,
            },
          ),
        ]);
        await useBelajarWajibTerjadwalStore().getCourseDetail(this.batchId);
        useUserStore().$patch({
          snackStatus: "green",
          snackbar: true,
          messageSnack: "Laporan sudah tersimpan.",
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
        }
      } finally {
        this.loading = false;
        this.$emit("closeUploadAssignmentDialog");
      }
    },
    async submitAssignment() {
      this.loading = true;
      const event = useRequestEvent();
      try {
        let path = "";
        let methods = "";
        let payload = {};
        if (this.selectedTugas.extendedProps.haveWorkingGroup) {
          const kelompokKerjaGuid = this.tugasPayload.guid;
          path = `/master-schedule/kelompok-kerja/${kelompokKerjaGuid}/submit-tugas`;
          methods = "PATCH";
          payload = new FormData();
          payload.append("file", this.tugasPayload.file);
        } else {
          path = `/master-schedule/tugas/aktifitas/${this.aktifitasGuid}`;
          methods = "POST";
          payload = new FormData();
          payload.append("file", this.tugasPayload.file);
          payload.append("description", this.tugasPayload.description);
        }
        await fetchBelajarWajib(event, path, methods, payload);
        await useBelajarWajibTerjadwalStore().getCourseDetail(this.batchId);
        useUserStore().$patch({
          snackStatus: "green",
          snackbar: true,
          messageSnack: "Tugas sudah tersimpan.",
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
        }
      } finally {
        this.loading = false;
        this.$emit("closeUploadAssignmentDialog");
      }
    },
    async getGroup() {
      const response = await useBelajarWajibTerjadwalStore().getKelompok(
        this.aktifitasGuid,
      );
      this.tugasPayload = { ...response };
      this.isSubmitted = !!response.tugasLink;
    },
    async getTugasSubmittedIndividu() {
      const response = await useBelajarWajibTerjadwalStore().getDetailTugas(
        this.aktifitasGuid,
      );
      this.tugasPayload = { ...response.data };
      this.isSubmitted = !!response.data.guid;
    },
    async getPolicyBriefAssignment() {
      const response =
        await useBelajarWajibTerjadwalStore().getPolicyBriefAssignment(
          this.aktifitasGuid,
        );
      this.tugasPayload = { ...response };
      this.tugasPayload.policyBrief = this.tugasPayload.link;
      this.isPolicyBriefSubmitted = !!response.link;
    },
    async getVisitationAssignment() {
      const response =
        await useBelajarWajibTerjadwalStore().getVisitationAssignment(
          this.aktifitasGuid,
        );
      this.tugasPayload = { ...response };
      if (this.tugasPayload.kelompokKerja?.anggotaList) {
        const { link } = this.tugasPayload.kelompokKerja.anggotaList.find(
          (anggota) => anggota.guidUser === this.profile.guidUser,
        );
        this.tugasPayload.visitationAssignmentForIndividual = link;
        this.isIndividualVisitationSubmitted = !!link;
        this.tugasPayload.visitationAssignmentForGroup = this.tugasPayload.link;
        this.isGroupVisitationSubmitted = !!this.tugasPayload.link;
      }
    },
    isValidLink(url) {
      if (!url) return false;
      for (const rule of this.rulesTugasLink) {
        const result = rule(url);
        if (result !== true) {
          return false;
        }
      }
      return true;
    },
    cancelEdit() {
      this.isEditMode = false;
      this.tugasPayload.file = [];
      // Reload data tugas yang sudah disubmit
      if (this.selectedTugas.extendedProps.haveWorkingGroup) {
        this.getGroup();
      } else {
        this.getTugasSubmittedIndividu();
      }
    },
    openPdfPreview() {
      if (!this.tugasPayload.guid) {
        useUserStore().$patch({
          snackStatus: "error",
          snackbar: true,
          messageSnack: "Data tugas tidak tersedia.",
        });
        return;
      }
      this.previewPdfDialog = true;
    },
    openPdfPreviewKelompok() {
      if (!this.tugasPayload.guid) {
        useUserStore().$patch({
          snackStatus: "error",
          snackbar: true,
          messageSnack: "Data tugas kelompok tidak tersedia.",
        });
        return;
      }
      openLinkOrPreview(this.tugasPayload.tugasLink, () => {
        this.kelompokPreviewPdfDialog = true;
      });
    },
  },
};
</script>
